import clsx from "clsx";
import { FunctionComponent } from "react";

import DangerouslySetCMSMarkup from "@ui/components/article/DangerouslySetCMSMarkup";
import MinusIcon from "@ui/components/icon/MinusIcon";
import PlusIcon from "@ui/components/icon/PlusIcon";
import * as styles from "@ui/components/navigation/LoopNav/LoopNav.css";
import { LoopNavSectionProps } from "@ui/components/navigation/LoopNav/loopNav.types";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

const LoopNavSectionTitle: FunctionComponent<
  Pick<LoopNavSectionProps, "open" | "onClick" | "permalink" | "text"> & {
    sectionId?: string;
    loopNavTitle: string;
  }
> = ({
  open = false,
  permalink,
  text: title,
  onClick,
  sectionId,
  loopNavTitle,
}) => {
  const analytics = useAnalytics();

  return permalink ? (
    <a
      className={styles.sectionTitle}
      href={permalink}
      onClick={() => {
        analytics?.emit({
          event: "loopnav",
          loopnav: {
            action: "click",
            loopnav_name: loopNavTitle,
            url: permalink,
            variant: "hyperlink",
          },
        });
        onClick();
      }}
    >
      {title}
    </a>
  ) : (
    <button
      className={clsx(styles.sectionTitle, open && styles.sectionTitleOpen)}
      onClick={onClick}
      aria-expanded={open ? "true" : "false"}
      aria-controls={sectionId}
      aria-label={`${open ? "Expand" : "Collapse"} '${title}' Section`}
    >
      <DangerouslySetCMSMarkup
        component="span"
        className={styles.sectionTitleText}
        html={title}
      />
      {open ? (
        <MinusIcon className={styles.sectionTitleIcon} />
      ) : (
        <PlusIcon className={styles.sectionTitleIcon} />
      )}
    </button>
  );
};

export default LoopNavSectionTitle;
